import { forwardRef, useId, type InputHTMLAttributes, type ReactNode } from 'react';

export type CheckboxProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'id'> & {
  label: ReactNode;
  inline?: boolean;
};

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(function Checkbox(
  { label, inline, className, ...rest },
  ref,
) {
  const generatedId = useId();
  const id = rest.name ? `${rest.name}-${generatedId}` : generatedId;
  const classes = ['m5-checkbox', inline ? 'm5-checkbox--inline' : null, className]
    .filter(Boolean)
    .join(' ');
  return (
    <label htmlFor={id} className={classes}>
      <input ref={ref} id={id} type="checkbox" {...rest} />
      <span>{label}</span>
    </label>
  );
});
